<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showNewTarjetaDictamen"
    no-close-on-backdrop
    title="Tarjetas / Dictamen"
    @hidden="resetModal"
  >
    <b-row v-if="accion == 'tarjeta'">
      <b-col md="5" style="display:grid; align-items:center">
        <v-select
          placeholder="Equipo"
          :clearable="false"
          class="select-size-sm"
          :options="listEquiposElegidos"
          v-model="equipoSeleccionado"
        />
      </b-col>
      <b-col md="2">
        <b-form-input
          v-model="numeroCamiseta"
          id="floating-camiseta"
          placeholder="#"
          size="sm"
        />
      </b-col>
      <b-col
        md="5"
        class="d-flex align-items-center"
        style="justify-content:space-around"
      >
        <b-form-radio name="some-radios" value="TA" v-model="tarjeta">
          T.A
        </b-form-radio>
        <b-form-radio name="some-radios" value="TR" v-model="tarjeta">
          T.R
        </b-form-radio>
        <b-form-radio name="some-radios" value="DOBLE_TA" v-model="tarjeta">
          2 T.A
        </b-form-radio>
      </b-col>
    </b-row>
    <b-row v-else-if="accion == 'dictamen'" class="mt-2">
      <b-col>
        <div class="form-label-group">
          <b-form-textarea
            v-model="dataPartido.dictamen"
            id="textarea"
            rows="3"
            placeholder="Dictámen"
          />
          <label for="label-textarea">Dictámen</label>
        </div>
      </b-col>
    </b-row>
    <template #modal-footer>
      <div class="w-100">
        <template v-if="!showLoading">
          <b-button
            v-if="
              USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.SANCIONES
            "
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="realizaAccion"
          >
            Guardar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
        </div>
        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>

<script>
import vSelect from 'vue-select'
import {
  BRow,
  BCol,
  BFormRadio,
  BFormInput,
  BFormTextarea,
  BButton,
  BAlert,
  BSpinner,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import store from '@/store'
import { heightFade } from '@core/directives/animations'
import Ripple from 'vue-ripple-directive'
import apiCall from '../../utils/apiCall'
import {
  URL,
  TARJETAS,
  USER,
  ROLES,
  // UBICACIONES,
  // xxxx,
  // xxxx,
} from '../../utils/variables'

export default {
  components: {
    BRow,
    BCol,
    vSelect,
    BFormRadio,
    BFormInput,
    BFormTextarea,
    BButton,
    BAlert,
    BSpinner,
  },
  directives: {
    // 'b-tooltip': VBTooltip,
    Ripple,
    heightFade,
  },
  props: {
    listEquiposElegidos: Array,
    dataPartido: Object,
    categoriaSeleccionada: Object,
    accion: String,
  },
  setup(props, { emit }) {
    const numeroCamiseta = ref(null)
    const equipoSeleccionado = ref(null)
    const tarjeta = ref(null)
    const showLoading = ref(false)
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const messageError = ref('')
    // const dictamen = ref('')
    const variante = ref('danger')
    const { postApi } = apiCall()
    function transformTarjet(tarjetaCreada) {
      const tarjetaDevuelta = {
        tAmarilla: 0,
        tRoja: 0,
        rojDobA: 0,
      }
      if (tarjetaCreada === TARJETAS.AMARILLA) {
        tarjetaDevuelta.tAmarilla = 1
      } else if (tarjetaCreada === TARJETAS.ROJA) {
        tarjetaDevuelta.tRoja = 1
      } else if (tarjetaCreada === TARJETAS.DOBLE_TA) {
        tarjetaDevuelta.rojDobA = 1
      }
      return tarjetaDevuelta
    }
    function initVariables() {
      showLoading.value = false
      equipoSeleccionado.value = null
      numeroCamiseta.value = null
      tarjeta.value = null
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // emit('recargar', props.playerSelected.id_equipo)
      // console.log('hidden')
      initVariables()
      // emit('reset', props.dataPartido)
      // props.dataSancion.motivo = null
      // props.dataSancion.duracion = 0
      // isManual.value = false
      // showLoading.value = false
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    // function defineAccion() {
    //   console.log(equipoSeleccionado)
    //   let action = ''
    //   if (equipoSeleccionado.value !== null) {
    //     action = 'tarjeta'
    //   }
    //   return action
    // }
    function validarDataTarjeta() {
      let error = false
      if (equipoSeleccionado.value === null) {
        error = true
        showMessageAlert('danger', 'Debe seleccionar un equipo')
      } else if (numeroCamiseta.value === null) {
        error = true
        showMessageAlert('danger', 'Número de camiseta no válido')
      } else if (tarjeta.value === null) {
        error = true
        showMessageAlert('danger', 'Debe elegir la tarjeta')
      }
      return error
    }

    async function insertTarjetaDictamen() {
      // const accion = defineAccion()
      // console.log(equipoSeleccionado.value)
      const hasError = validarDataTarjeta()
      if (!hasError) {
        showLoading.value = true
        const tarjetaEnviar = transformTarjet(tarjeta.value)
        const path = 'ApiFixture/insertarTarjetaIndepenediente'
        const data = {
          idCategoria: props.dataPartido.id_categoria,
          idEquipo: equipoSeleccionado.value.value,
          numCamiseta: numeroCamiseta.value,
          idPartido: props.dataPartido.id_partido,
          disciplina: props.dataPartido.disciplina,
          tAmar: tarjetaEnviar.tAmarilla,
          tRoja: tarjetaEnviar.tRoja,
          tdobAmar: tarjetaEnviar.rojDobA,
          idCampeonato: props.dataPartido.id_campeonato,
          idUsuario: USER().id_usuario,
          dataMovimiento: `${equipoSeleccionado.value.label} ${props.dataPartido.categoria}  partido del ${props.dataPartido.fecha} - ${props.dataPartido.local} vs ${props.dataPartido.visita} `,
          idTorneo:
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        }
        // console.log(data)
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          // console.log('si')
          showMessageAlert('success', 'Tarjeta agregada exitosamente')
          emit('reset', props.dataPartido)
          initVariables()
        } else {
          showMessageAlert('danger', response.mensaje)
        }
        showLoading.value = false
      }
    }
    async function insertDictamen() {
      // const accion = defineAccion()
      // console.log(accion)
      showLoading.value = true
      const path = 'ApiFixture/updateDictamen'
      const data = {
        idPartido: props.dataPartido.id_partido,
        dictamen_env: props.dataPartido.dictamen,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        // console.log('si')
        showMessageAlert('success', 'Dictamen actualizado exitosamente')
        props.dataPartido.dictamen = data.dictamen_env
      } else {
        showMessageAlert('danger', 'Ha ocurrido un error')
      }
      showLoading.value = false
    }

    function realizaAccion() {
      if (props.accion === 'tarjeta') {
        insertTarjetaDictamen()
      } else {
        insertDictamen()
      }
    }

    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_TARJETA_DICTAMEN', false)
    }
    return {
      showLoading,
      dismissCountDown,
      dismissSecs,
      messageError,
      variante,
      countDownChanged,
      showMessageAlert,
      onlyClose,
      insertTarjetaDictamen,
      numeroCamiseta,
      equipoSeleccionado,
      tarjeta,
      resetModal,
      realizaAccion,
      ROLES,
      USER,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
